import React, { useState } from 'react'
import '../Style/main.css'
import '../Style/responsive.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { downloadCertificate } from '../Http/ApiCalls'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import BounceLoader from 'react-spinners/BounceLoader'
import logo from '../Images/logo.png'
import { RWebShare } from 'react-web-share'
import dpImg from '../Images/user.png'
const SubmitPage = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const override = {
        display: 'block',
        margin: ' 400px auto',
        borderColor: 'red'
    }

    if (!location.state) {
        return (window.location.href = '/')
    }
    const userData = location.state.userData
    const handleSubmit = (event) => {
        setLoading(true)
        event.preventDefault()
        downloadCertificate(userData.id, userData)
            .then(({ data }) => {
                setLoading(false)
                if (data.status === 200) {
                    const url = data.imgUrl
                    fetch(url)
                        .then((response) => response.blob())
                        .then((blob) => {
                            const url = URL.createObjectURL(blob)
                            const link = document.createElement('a')
                            link.href = url
                            link.download = 'Certificate.jpg'
                            document.body.appendChild(link)
                            link.click()
                            document.body.removeChild(link)
                            URL.revokeObjectURL(url)
                        })
                    toast('Certificate Downloaded', {
                        position: 'top-right',
                        autoClose: 3000,
                        type: 'success',
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: 'light'
                    })
                    return navigate('/')
                }
            })
            .catch((err) => {
                setLoading(false)
                toast('Error while downloading', {
                    position: 'top-right',
                    autoClose: 3000,
                    type: 'error',
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: 'light'
                })
            })
    }

    return (
        <div className="submitPage container-fluid">
            {loading ? (
                <>
                    <BounceLoader
                        color={'#120E43'}
                        loading={true}
                        size={60}
                        cssOverride={override}
                    />
                </>
            ) : (
                <>
                    <div className="headerSection">
                        <div className="topSection">
                            <a href="https://influencercommunityofindia.com/">
                                <img
                                    src={logo}
                                    alt=""
                                    id="logo"
                                />
                            </a>
                            <div className="buttons">
                                <button>
                                    <a
                                        href="https://survey.influencercommunityofindia.com/"
                                        target="_blank"
                                        rel="noreferrer">
                                        Take a survey
                                    </a>
                                </button>
                                <RWebShare
                                    data={{
                                        text: 'Hey, I have used this amazing calculator to know my ideal price and I invite you to take the same in an effort to boost the influencer community:',
                                        url: 'https://calculator.influencercommunityofindia.com/',
                                        title: 'ICI'
                                    }}>
                                    <button id="shareBtn">Share</button>
                                </RWebShare>
                            </div>
                        </div>
                        <p id="heading">
                            Hello there, here’s the estimated cost per post in correspondence to your followers and the average engagement rate.
                        </p>
                    </div>
                    <div className="content">
                        <div className="userSection">
                            <div className="userData">
                                <img
                                    src={userData.dpUrl || dpImg}
                                    alt="userProfile"
                                />
                                <div className="profile">
                                    <h4>@{userData.username}</h4>
                                    <h6>{userData.name}</h6>
                                    <p>{userData.bio}</p>
                                </div>
                            </div>

                            <div className="cost">
                                <h5>Estimated Cost</h5>
                                <h2>
                                    {' '}
                                    {'₹  '}
                                    {userData.roundedValue}
                                    {'/-'}
                                </h2>
                                <p id="acceptText">Accept the price & Download your certificate !</p>

                                <button
                                    onClick={handleSubmit}
                                    id="downloadCertificate">
                                    Download Certificate
                                </button>
                            </div>
                        </div>
                        <div className="cardSection">
                            <div className="row">
                                <div className="col-lg-3 col-6">
                                    <div className="cardBody">
                                        <h6>Followers</h6>
                                        <h2>{userData.followers}</h2>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="cardBody">
                                        <h6>Engagement Rate</h6>
                                        <h2>{userData.engagementRate.toFixed(2)}%</h2>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="cardBody">
                                        <h6>Average Likes</h6>
                                        <h2>{userData.averageLikes.toFixed(0)}</h2>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-6">
                                    <div className="cardBody">
                                        <h6>Average Comments</h6>
                                        <h2>{userData.averageComments.toFixed(0)}</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ToastContainer />
                </>
            )}
        </div>
    )
}

export default SubmitPage
